import React from "react";

interface TechGroupProps {
  icon: React.ReactNode;
  label: string;
  items: string[];
}

const TechGroup: React.FC<TechGroupProps> = ({ icon, label, items }) => (
  <div className="rounded-2xl border border-slate-700/70 bg-slate-900/70 p-4 dark:bg-slate-50 dark:border-slate-200">
    <div className="mb-3 flex items-center gap-2">
      <div className="flex h-7 w-7 items-center justify-center rounded-full bg-emerald-500/15 text-emerald-300 dark:bg-emerald-100 dark:text-emerald-700">
        {icon}
      </div>
      <h3 className="text-xs font-semibold uppercase tracking-wide text-slate-200 dark:text-slate-800">
        {label}
      </h3>
    </div>
    <ul className="space-y-1 text-xs text-slate-300 dark:text-slate-700">
      {items.map((item) => (
        <li key={item} className="flex items-center gap-2">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-400/70 dark:bg-emerald-500" />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  </div>
);

export default TechGroup;
